export const ONE_LINE_CHARACTERS_LIMIT: number = 110 // # based on 1366px screen width
